import { type MantineColorsTuple, createTheme } from '@mantine/core';

/* The console's look comes from the app's design tokens (docs/design/foundations.md on the design-system
 * branch): DM Sans, a monochrome palette with black as the primary action, the measured #F2F2F2 field
 * fill and #737373 secondary text, status colours from the spec. Mantine does the components. */

// Black primary: Mantine needs ten shades; the filled button uses shade 9.
const ink: MantineColorsTuple = [
  '#f2f2f2',
  '#e6e6e6',
  '#d9d9d9',
  '#bfbfbf',
  '#a6a6a6',
  '#737373',
  '#525252',
  '#454545',
  '#1f1f1f',
  '#000000',
];

const gray: MantineColorsTuple = [
  '#f6f6f8',
  '#f2f2f2',
  '#ededed',
  '#d9d9d9',
  '#d0d5dd',
  '#a3a3a3',
  '#737373',
  '#454545',
  '#262626',
  '#101010',
];

export const theme = createTheme({
  fontFamily: "'DM Sans Variable', system-ui, sans-serif",
  headings: { fontFamily: "'DM Sans Variable', system-ui, sans-serif", fontWeight: '700' },
  primaryColor: 'ink',
  primaryShade: { light: 9, dark: 0 },
  colors: { ink, gray },
  black: '#000000',
  defaultRadius: 'md',
  radius: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '24px' },
  cursorType: 'pointer',
  focusRing: 'auto',
  components: {
    TextInput: { defaultProps: { variant: 'filled' } },
    Select: { defaultProps: { variant: 'filled' } },
    NumberInput: { defaultProps: { variant: 'filled' } },
    Textarea: { defaultProps: { variant: 'filled' } },
    MultiSelect: { defaultProps: { variant: 'filled' } },
    Chip: { defaultProps: { variant: 'filled' } },
    Table: { defaultProps: { verticalSpacing: 'sm', highlightOnHover: true } },
  },
});
